import React, { useContext, useEffect } from "react";
import { globalHistory } from "@reach/router";
import { AppContext } from "@context/AppContext";
import { hamburgerMenu, hamburgerOpen } from "@styles/mobileMenu.module.css";

const MobileMenu = () => {
  const { openSidebar, closeSidebar, isSidebarOpen } = useContext(AppContext);
  const handleClick = () => (isSidebarOpen ? closeSidebar : openSidebar);

  useEffect(() => {
    // Lock vertical sroll while sidebar is open
    if (isSidebarOpen) {
      document.documentElement.classList.add("no-scroll");
      document.body.classList.add("no-scroll");
    } else {
      document.documentElement.classList.remove("no-scroll");
      document.body.classList.remove("no-scroll");
    }
    // Close sidebar on navigate to new page
    return globalHistory.listen(({ action }) => {
      if (action === "PUSH") closeSidebar();
    });
  }, [isSidebarOpen]);

  return (
    <button
      onClick={handleClick()}
      className={`flex h-[50px] w-[50px] items-center justify-center rounded-full shadow-[2px_2px_4px_#5D5054CC] transition duration-300 lg:hidden ${
        isSidebarOpen ? "bg-lightPink pl-[10px]" : "bg-salmon"
      }`}
    >
      <div className={`${hamburgerMenu} ${isSidebarOpen && hamburgerOpen}`}>
        <span />
      </div>
    </button>
  );
};

export default MobileMenu;
